
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 16A8 8 0 118 0a8 8 0 010 16zM4.883 5.935c.551 0 .998-.407.998-.91 0-.503-.447-.91-.998-.91-.55 0-.997.407-.997.91 0 .503.446.91.997.91zm-.769 5.854h1.79V6.63h-1.79v5.16zm4.301-2.87c0-.592.28-1.17.95-1.17.669 0 .834.578.834 1.156v2.818h1.78V8.79c0-2.039-1.204-2.39-1.945-2.39-.74 0-1.149.25-1.619.857v-.694H6.629v5.16h1.786V8.92z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    